module.exports = __webpack_public_path__ + "img/UT.b58abc33.jpg";